import e from "@dialpad/dialtone-tokens/layered/contrast/tokens-high-contrast.css?inline";
//#region themes/high-contrast.js
var t = { contrast: {
	css: e,
	name: "high"
} };
//#endregion
export { t as default };
